module.exports = __webpack_public_path__ + "img/location-search-bar.319e56b6.svg";